export enum WageConditionalAction {
  None = 0,
  Threshold = 1,
  Action = 2,
  WGerring = 3
}

export const WageConditionalActionMapping: Record<
  WageConditionalAction,
  string
> = {
  [WageConditionalAction.None]: '-- Select Action --',
  [WageConditionalAction.Threshold]: 'Pay Threshold',
  [WageConditionalAction.Action]: 'Pay Action',
  [WageConditionalAction.WGerring]: 'Pay Wayne G.'
};
